import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'

import i18n from '../i18n'
import Form from '../components/AcademyRegistration/Form'
import StepsByDocs from '../components/Steps/StepsByDocs'
import LoaderDots from '../components/loaderDots'
import { initGA } from '../components/analytics'
import CurrencyChecker from '../components/currencyChecker'

import IconBackgroundCheck from '../images/shared/icon-background-check-white.png'
import IconAcademyInformations from '../images/shared/icon-academy-informations-white.png'
import IconAdditionalProfessors from '../images/shared/icon-additional-professors-white.png'
import IconAssociation from '../images/shared/icon-association-white.png'
import IconSafeSport from '../images/shared/icon-safe-sport-white.png'
import IconPayment from '../images/shared/icon-payment-white.png'

const stepsRawData = [
  {
    id: 'bgCheck',
    title: i18n.t('academyRegistration.steps.bgCheck.title'),
    icon: IconBackgroundCheck,
    description: i18n.t('academyRegistration.steps.bgCheck.description'),
    linkLabel: 'Read more and Apply',
    linkUrl: '/background-check',
  },
  {
    id: 'safeSport',
    title: i18n.t('academyRegistration.steps.safeSport.title'),
    icon: IconSafeSport,
    description: i18n.t('academyRegistration.steps.safeSport.description'),
    linkLabel: 'Read more and Apply',
    linkUrl: '/safe-sport',
  },
  {
    id: 'academyForm',
    title: i18n.t('academyRegistration.steps.academyForm.title'),
    icon: IconAcademyInformations,
    description: i18n.t('academyRegistration.steps.academyForm.description'),
    linkLabel: i18n.t('academyRegistration.stepsReadMore'),
    linkUrl: '/academy-registration-informations',
  },
  {
    id: 'additionalProfessors',
    title: i18n.t('academyRegistration.steps.additionalProfessors.title'),
    icon: IconAdditionalProfessors,
    description: i18n.t(
      'academyRegistration.steps.additionalProfessors.description'
    ),
  },
  {
    id: 'association',
    title: i18n.t('academyRegistration.steps.association.title'),
    icon: IconAssociation,
    description: i18n.t('academyRegistration.steps.association.description'),
  },
  {
    id: 'payment',
    title: i18n.t('academyRegistration.steps.payment.title'),
    icon: IconPayment,
    description: i18n.t('academyRegistration.steps.payment.description'),
  },
]

class AcademyRegistration extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formInputs: {
        auxiliaryInstructors: undefined,
        association: undefined,
        country: undefined,
      },
      showSteps: false,
      fee: undefined,
      currency: undefined,
      loading: false,
      steps: [],
      docs: [],
      countriesOptions: [],
    }
  }

  componentDidMount() {
    initGA()
  }

  async componentDidUpdate(_, prevState) {
    if (
      this.state.showSteps &&
      JSON.stringify(this.state.formInputs) !==
        JSON.stringify(prevState.formInputs)
    ) {
      await this.fetchDocuments()
    }
  }

  async fetchDocuments() {
    const { auxiliaryInstructors, association, country } = this.state.formInputs

    let params = {
      hasAssistantProfessors: auxiliaryInstructors.value,
      belongsToAssociation: association.value,
      countryCode: country.value,
    }

    await axios
      .get('/api/v1/academies/registration_docs.json', {
        params: params,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      .then((response) =>
        this.setState({
          docs: response.data.documents,
          currency: CurrencyChecker(response.data.currency),
          fee: response.data.price,
          showSteps: true,
        })
      )
      .catch((error) => console.error(error))
  }

  validateForm() {
    const { auxiliaryInstructors, association, country } = this.state.formInputs

    if (auxiliaryInstructors == undefined) return false
    if (association == undefined) return false
    if (country == undefined) return false

    return true
  }

  async handleSubmitEvent() {
    this.setState({ loading: true })

    if (await !this.validateForm()) {
      this.setState({ loading: false })
      return null
    }

    await this.fetchDocuments()
    this.setState({ loading: false })
  }

  updateInputState(e) {
    this.setState({
      formInputs: Object.assign({}, this.state.formInputs, {
        [e.target.name]: e.target.value,
      }),
    })
  }

  handleRegisterAcademyEvent() {
    const country = this.state.formInputs.country
    const countryQueryParams = country
      ? `?countryName=${country.label}&countryCode=${country.value}`
      : ''

    window.location.href = `${App.INFOSITE_APP_URL}/athletes/academies/registrations${countryQueryParams}`
  }

  componentChooser() {
    if (this.state.loading) return <LoaderDots />

    if (this.state.showSteps) {
      return (
        <div>
          <Form
            isInline={true}
            handleSubmitEvent={this.handleRegisterAcademyEvent.bind(this)}
            updateInputState={this.updateInputState.bind(this)}
            formInputs={this.state.formInputs}
            currentAge={this.state.currentAge}
            countriesOptions={this.state.countriesOptions}
            submitLabel={i18n.t('academyRegistration.form.create')}
            submitClass="btn-warning"
            i18n={i18n}
          />

          <StepsByDocs
            type={'academyRegistration'}
            currency={this.state.currency}
            fee={this.state.fee}
            docs={this.state.docs}
          />

          <a
            onClick={this.handleRegisterAcademyEvent.bind(this)}
            className="btn btn-warning mt-4 w-100 d-xl-none"
          >
            {i18n.t('academyRegistration.form.create')}
          </a>
        </div>
      )
    } else {
      return (
        <div>
          <section className="row title-page">
            <div className="col-sm-12">
              <h1>{i18n.t('academyRegistration.application')}</h1>
              <h3>{i18n.t('academyRegistration.form.fillInfo')}</h3>
            </div>
          </section>

          <section className="row">
            <div className="col-sm-12 col-md-5">
              <Form
                handleSubmitEvent={this.handleSubmitEvent.bind(this)}
                updateInputState={this.updateInputState.bind(this)}
                formInputs={this.state.formInputs}
                currentAge={this.state.currentAge}
                submitLabel={i18n.t('academyRegistration.form.next')}
                submitClass="btn-outline-primary"
                onCountriesFetched={(countriesOptions) =>
                  this.setState({ countriesOptions })
                }
                i18n={i18n}
              />
            </div>
          </section>
        </div>
      )
    }
  }

  render() {
    return (
      <div id="main-container" className="container">
        <div className="row">
          <div className="col">{this.componentChooser()}</div>
        </div>
      </div>
    )
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <AcademyRegistration />,
    document.querySelector('#academy-registration-page')
  )
})
